import { useEffect } from "react";

type SeoConfig = {
  title: string;
  description?: string;
  jsonLd?: object[];
};

export function useSeo({ title, description, jsonLd = [] }: SeoConfig) {
  useEffect(() => {
    document.title = title;
    let meta: HTMLMetaElement | null = null;
    if (description) {
      meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    return () => {
      meta?.remove();
    };
  }, [title, description]);

  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    jsonLd.forEach((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    });
    return () => {
      scripts.forEach((s) => s.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonLd]);
}